const ID_FIELDS = ['uuid', 'property_uuid', 'id', 'legacy_id'] as const;

export function entityIdentityCandidates(entity: Record<string, any> | null | undefined): string[] {
  if (!entity) return [];
  return Array.from(new Set(ID_FIELDS
    .map((field) => entity[field])
    .filter((value) => value !== undefined && value !== null && value !== '')
    .map(String)));
}

export function canonicalEntityId(entity: Record<string, any> | null | undefined): string {
  return entityIdentityCandidates(entity)[0] || '';
}

export function entityMatchesId(entity: Record<string, any> | null | undefined, id: unknown): boolean {
  if (id === undefined || id === null || id === '') return false;
  return entityIdentityCandidates(entity).includes(String(id));
}

export function findEntityById<T extends Record<string, any>>(entities: T[], id: unknown): T | undefined {
  return entities.find((entity) => entityMatchesId(entity, id));
}

export function entitiesShareIdentity(a: Record<string, any>, b: Record<string, any>): boolean {
  const right = new Set(entityIdentityCandidates(b));
  return entityIdentityCandidates(a).some((id) => right.has(id));
}

